<template>
	<div>
		<layout v-if="HasUser && LinksLoaded">
			<template #header>
				<nav-toolbar></nav-toolbar>
			</template>

			<template #main>
				<router-view></router-view>
			</template>

			<template #footer>
				<div class="footer">
					<div>
						<a href="https://www.seltec.at/privacy" target="_blank">DSGVO</a> |
						<a href="https://www.seltec.at/terms" target="_blank">AGB</a> |
						<a href="https://www.seltec.at/imprint" target="_blank">Impressum</a>
					</div>
					<p class="ma-0">© {{new Date().getFullYear()}} by Seltec GmbH
						<span style="color:red; font-weight:bold;"><!--REPLACE_ME--></span>
					</p>
				</div>
			</template>
		</layout>
		<v-app v-else><spinner :loading="true"></spinner></v-app>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import errorActions from './store/actions/error';
import userActions from './store/actions/user';
import rootActions from './store/actions/root';
import namespace from './store/namespace';

import Layout from './general/Layout.vue';
import NavToolbar from './navigation/Toolbar.vue';
import Spinner from './general/Spinner.vue';

export default {
	name: 'app',
	components: {
		Layout,
		NavToolbar,
		Spinner,
	},
	async created() {
		await this.GET_ROOT_LINKS();

		if (this.IsAuthenticated) {
			await this.GET_ROOT_LINKS_AUTH();
			await this.GET_CURRENT_USER();
		}
	},
	computed: {
		...mapGetters(namespace.AUTH, ['IsAuthenticated']),
		...mapGetters(namespace.USER, ['HasUser']),
		...mapGetters(['LinksLoaded']),
	},
	methods: {
		...mapActions([rootActions.GET_ROOT_LINKS,
			rootActions.GET_ROOT_LINKS_AUTH]),
		...mapActions(namespace.USER, [userActions.GET_CURRENT_USER]),
		...mapActions(namespace.ERROR, [errorActions.SET_ERROR]),
	},
	async errorCaptured(err) {
		if (!err.response) {
			if (err.message.includes('response is undefined')) {
				this.SET_ERROR(this.$i18n.t('text.error500'));
			} else {
				this.SET_ERROR(err.message);
			}
		} else {
			switch (err.response.status) {
			case 403:
				this.SET_ERROR(this.$i18n.t('text.error403')); break;
			case 404:
				this.SET_ERROR(this.$i18n.t('text.error404')); break;
			case 400:
				this.SET_ERROR(this.$i18n.t('text.error400')); break;
			case 422:
				this.SET_ERROR(this.$i18n.t('text.error422')); break;
			case 500:
				this.SET_ERROR(this.$i18n.t('text.error500')); break;
			default: this.SET_ERROR(err.message); break;
			}
		}

		return false;
	},
};
</script>

<style lang="scss" scoped>
body {
    background: white;
    margin: 0;
    padding: 0;
    background-attachment: fixed;
}

.footer {
	width: 100%;
	text-align: center;
	font-size:12px;

	div a {
		color: #000;
	}
}
</style>
